import { ViewStyle } from "react-native";
import { BMPrimitives } from "@traveloka/district-bloom";

export type SpotlightPosition = "bottom-left" | "bottom-right" | "center";

export const POSITION_STYLES: Record<SpotlightPosition, ViewStyle> = {
  center: {
    top: 0,
    left: 0,
    right: 0,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: BMPrimitives.BMSize.md,
  },
  "bottom-left": { left: 0 },
  "bottom-right": { right: 0 },
};

export const DEFAULT_WIDTH = 362;
export const CAROUSEL_CARD_HEIGHT = 444;
export const SPOTLIGHT_TRANSITION_DURATION = 300;
export const OFFSCREEN_Y = 150;

export const ACTIVE_DOT_SIZE = 14;
export const INACTIVE_DOT_SIZE = 10;
export const DOT_GAP = 5;
export const INACTIVE_DOT_COLOR = "#d9d9d9";
export const DOT_TRANSITION_DURATION = 200;
